import type { SVGProps } from 'react';

import { cn } from '../lib/cn';

/** Indicateur de chargement inline, hérite de `currentColor`. */
export function Spinner({ className, ...props }: Omit<SVGProps<SVGSVGElement>, 'viewBox'>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={cn('size-4 shrink-0 animate-spin', className)}
      {...props}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
